import qs from 'qs';
import { getBasePathTracking } from 'utils';

export const trackSplunk = (entries, customSplunkUrl = null) => {
  const { trackingUrl } = getBasePathTracking(customSplunkUrl);
  return fetch(`${trackingUrl}/?${qs.stringify(entries)}`);
};

export const trackStreamfully = (entries, customStreamfullyUrl = null) => {
  const { REACT_APP_STREAMFULLY_URL } = process.env;
  const { et, st, ...entriesRest } = entries;
  return fetch(
    `${customStreamfullyUrl || REACT_APP_STREAMFULLY_URL}/?${qs.stringify({ st, et })}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      body: JSON.stringify(entriesRest),
    },
  );
};
